import angular from "angular";
import HomeLandingBrandsSectionComponent from "./home-landing-brands.component";
import LandingPageModule from "../../../../components/landing-page/landing-page.module";

export default angular.module("vt-public-home-landing-brands.module", [
    LandingPageModule.name
]).component("homeLandingBrandsSection", HomeLandingBrandsSectionComponent);
